<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Papír bizonyítvány (jóváhagyott nyomtatvány)</ion-title>
    <ion-buttons slot="end"><ion-button (click)="bezar()">Bezárás</ion-button></ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment [(ngModel)]="ful" (ionChange)="fulValt()" [scrollable]="true">
      <ion-segment-button value="nyomtatas"><ion-label>Nyomtatás</ion-label></ion-segment-button>
      <ion-segment-button value="szamadas"><ion-label>Szigorú számadás</ion-label></ion-segment-button>
      <ion-segment-button value="szabaly"><ion-label>Évfolyam-szabály</ion-label></ion-segment-button>
      <ion-segment-button value="elrendezes"><ion-label>Elrendezés</ion-label></ion-segment-button>
      <ion-segment-button value="sablon"><ion-label>Sablonok</ion-label></ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- ═══════════════ NYOMTATÁS ═══════════════ -->
  <ng-container *ngIf="ful === 'nyomtatas'">
    <p class="halvany">
      A digitális bizonyítvány felmenő rendszerben jön (Nkt. 99/M. §): 2025/2026-tól az 1. évfolyamon, a gimnázium
      9. évfolyamán, a hat/nyolc évfolyamos gimnázium belépő évfolyamán. A többi évfolyam <b>papír bizonyítványt</b> kap,
      és az csak a miniszter által <b>jóváhagyott, előnyomott nyomtatványon</b> adható ki (Nkt. 57. § (5)). Ide a rendszer
      csak az adatokat nyomtatja, a nyomtatvány megfelelő helyeire. A nyomtatvány sorszáma szigorú számadású.
    </p>

    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12" size-md="5">
          <ion-select label="Osztály" label-placement="stacked" interface="popover" [(ngModel)]="osztaly" (ionChange)="osztalyValt()" placeholder="Válassz osztályt">
            <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">
              {{ o.osztaly }}<ng-container *ngIf="osztalyForma(o.id) as f"> – {{ formaNev(f.forma) }}</ng-container>
            </ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col size="12" size-md="4">
          <ion-select label="Nyomtatvány" label-placement="stacked" interface="popover" [(ngModel)]="tipus" (ionChange)="tipusValt()">
            <ion-select-option *ngFor="let n of elrLista" [value]="n.tipus">{{ n.kod }} – {{ n.nev }}</ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col size="12" size-md="3">
          <ion-input type="date" label="Keltezés" label-placement="stacked" [(ngModel)]="keltDatum"></ion-input>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div *ngIf="fut && !nevsor" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <ng-container *ngIf="nevsor">
      <div class="szabaly-sav" [class.digitalis]="nevsor.szabaly.forma === 'digitalis'" [class.papir]="nevsor.szabaly.forma === 'papir'">
        <b>{{ nevsor.osztaly.nev }}: {{ formaNev(nevsor.szabaly.forma) }} bizonyítvány</b>
        <span *ngIf="nevsor.szabaly.felulirt"> (kézzel felülírva)</span>
        <div>{{ nevsor.szabaly.indok }}</div>
        <div *ngIf="nevsor.szabaly.bizonytalan" class="figyel">
          A képzés típusa {{ forrasNev(nevsor.szabaly.kepzes_forras) }} ({{ nevsor.szabaly.kepzes_nev }}) – ellenőrizd az Évfolyam-szabály fülön.
        </div>
        <div *ngIf="nevsor.szabaly.forma === 'digitalis' && !papirOsztaly" class="figyel">
          Ennek az osztálynak digitális bizonyítvány jár (Bizonyítvány sablon, aláírás és tárolás) – papírra nem nyomtatható.
        </div>
        <div *ngIf="nevsor.szabaly.szakkepzo && papirOsztaly && nevsor.szabaly.forma === 'digitalis'" class="figyel">
          Szakképző intézmény: a tanulmányok kezdete tanulónként dönt (Szkt. 128/C. §) – csak a papír bizonyítványos tanulók nyomtathatók.
        </div>
      </div>

      <p class="figyel" *ngIf="nevsor.ertekeles_hianyzik">Ehhez az osztályhoz még nincs év végi értékelés.</p>

      <ng-container *ngIf="papirOsztaly && tetelek.length">
        <div class="tomeges">
          <ion-input label="Sorozatjel" label-placement="stacked" fill="outline" [(ngModel)]="tomegSorozat" placeholder="pl. AB" class="rovid"></ion-input>
          <ion-input label="Kezdő sorszám" label-placement="stacked" fill="outline" [(ngModel)]="tomegKezdo" placeholder="pl. 0012345" class="kozepes"></ion-input>
          <ion-button fill="outline" (click)="tomegesKitoltes()">Kitöltés a szám nélkülieknek</ion-button>
          <ion-button fill="clear" color="medium" (click)="sorszamTorol()">Ki nem adott számok törlése</ion-button>
          <ion-checkbox [(ngModel)]="fuzetFolytatas" (ionChange)="nevsorToltes()" labelPlacement="end">A korábbi füzet folytatása (előző évi sorszám)</ion-checkbox>
        </div>

        <table class="tabla">
          <thead>
            <tr>
              <th><ion-checkbox [checked]="kijeloltDb === tetelek.length" (ionChange)="osszesKijelol($event.detail.checked)"></ion-checkbox></th>
              <th>Tanuló</th><th>Sorozat</th><th>Sorszám</th><th>Állapot</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tetelek" [class.halvany-sor]="!t.kijelolt">
              <td><ion-checkbox [(ngModel)]="t.kijelolt"></ion-checkbox></td>
              <td>{{ t.nev }}<div class="kicsi">{{ t.oktazon }}</div>
                <div *ngIf="t.formaIndok" class="kicsi" [class.figyel]="t.forma === 'digitalis'">{{ formaNev(t.forma) }}: {{ t.formaIndok }}</div></td>
              <td><ion-input class="cella rovid" [(ngModel)]="t.sorozat" [readonly]="!!t.kiadott"></ion-input></td>
              <td><ion-input class="cella kozepes" [(ngModel)]="t.sorszam" [readonly]="!!t.kiadott" [class.hiba]="t.kijelolt && !t.sorszam"></ion-input></td>
              <td class="kicsi">
                <div *ngIf="t.kiadott" class="zold">
                  Kiadva: {{ t.kiadott.sorozat }} {{ t.kiadott.sorszam }}
                  <ion-button size="small" fill="clear" color="danger" (click)="allapotValt(t.kiadott.id, 'rontott', t.nev + ' – ' + t.kiadott.sorozat + ' ' + t.kiadott.sorszam)">Rontott</ion-button>
                </div>
                <div *ngIf="!t.kiadott && t.korabbi">Füzet: {{ t.korabbi.sorozat }} {{ t.korabbi.sorszam }} ({{ t.korabbi.tanev }}/{{ t.korabbi.tanev + 1 }})</div>
                <div *ngFor="let r of t.rontottak" class="piros">{{ r.allapot }}: {{ r.sorozat }} {{ r.sorszam }}</div>
                <div *ngIf="!t.kiadott && !t.korabbi && !t.rontottak.length" class="halvany">új nyomtatvány</div>
              </td>
            </tr>
          </tbody>
        </table>

        <ion-list lines="none" class="opciok">
          <ion-item>
            <ion-select label="Személyi adatok oldala" label-placement="stacked" interface="popover" [(ngModel)]="szemelyi">
              <ion-select-option value="auto">Csak új nyomtatványnál (a füzet első kitöltésekor)</ion-select-option>
              <ion-select-option value="mind">Mindenkinél</ion-select-option>
              <ion-select-option value="nem">Senkinél</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngFor="let o of evfolyamOldalak">
            <ion-checkbox [(ngModel)]="oldalValasztas[o.kulcs]" labelPlacement="end">{{ o.nev || o.kulcs }}</ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-checkbox [(ngModel)]="csakElsoKeresztnev" labelPlacement="end">Osztályfőnöknél csak az első keresztnév</ion-checkbox>
          </ion-item>
        </ion-list>

        <div class="gombok">
          <ion-button fill="outline" (click)="nyomtat(true)" [disabled]="fut || !kijeloltDb">
            <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
          </ion-button>
          <ion-button (click)="nyomtat(false)" [disabled]="fut || !kijeloltDb">
            <ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás és sorszámok rögzítése ({{ kijeloltDb }})
          </ion-button>
        </div>
        <p class="halvany">
          Nyomtatáskor a nyomtatóban „tényleges méret” (100%) legyen, ne „oldalhoz igazítás”. Előbb egy sima lapra érdemes
          kinyomtatni, és fény felé tartva a nyomtatványra illeszteni. Az előnézet nem rögzít semmit.
        </p>
      </ng-container>

      <div *ngIf="hibak.length" class="uzenetek piros">
        <b>A sorszámok nem adhatók ki:</b>
        <div *ngFor="let h of hibak">{{ h.nev }}: {{ h.hiba }}</div>
      </div>
      <div *ngIf="figyelmeztetesek.length" class="uzenetek figyel">
        <b>Figyelem:</b>
        <div *ngFor="let f of figyelmeztetesek">{{ f }}</div>
      </div>
    </ng-container>
  </ng-container>

  <!-- ═══════════════ SZIGORÚ SZÁMADÁS ═══════════════ -->
  <ng-container *ngIf="ful === 'szamadas'">
    <p class="halvany">
      A bizonyítványnyomtatvány szigorú számadású: minden sorszámról (sorozatjel + sorszám) számot kell adni –
      kinek adták ki, melyik tanévben, illetve ha elrontották vagy bevonták, miért. A rontott vagy bevont sorszám
      többé nem használható.
    </p>
    <div class="tomeges">
      <ion-input label="Tanév (kezdő év)" label-placement="stacked" fill="outline" [(ngModel)]="szamadasEv" class="kozepes" placeholder="mind"></ion-input>
      <ion-select label="Állapot" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="szamadasAllapot" class="kozepes">
        <ion-select-option value="">Mind</ion-select-option>
        <ion-select-option value="kiadott">Kiadott</ion-select-option>
        <ion-select-option value="rontott">Rontott</ion-select-option>
        <ion-select-option value="bevont">Bevont</ion-select-option>
      </ion-select>
      <ion-input label="Keresés" label-placement="stacked" fill="outline" [(ngModel)]="szamadasKereso" (keyup.enter)="szamadasToltes()" placeholder="név, azonosító, sorszám"></ion-input>
      <ion-button (click)="szamadasToltes()"><ion-icon slot="start" name="search-outline"></ion-icon>Keresés</ion-button>
      <ion-button fill="outline" (click)="szamadasPdf()"><ion-icon slot="start" name="print-outline"></ion-icon>Nyilvántartás nyomtatása</ion-button>
    </div>

    <table class="tabla">
      <thead><tr><th>Nyomtatvány</th><th>Sorozat, sorszám</th><th>Tanév</th><th>Tanuló</th><th>Osztály</th><th>Állapot</th><th>Ok / megjegyzés</th><th>Rögzítette</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let s of szamadas" [class.rontott]="s.allapot !== 'kiadott'">
          <td>{{ tipusKod(s.nyomtatvany_tipus) }}</td>
          <td><b>{{ s.sorozat }} {{ s.sorszam }}</b></td>
          <td>{{ s.tanev }}/{{ s.tanev + 1 }}</td>
          <td>{{ s.tanulo_nev || '—' }}<div class="kicsi">{{ s.oktazon }}</div></td>
          <td>{{ s.osztaly_nev }}</td>
          <td>{{ s.allapot }}</td>
          <td class="kicsi">{{ s.ok }}<div *ngIf="s.megjegyzes">{{ s.megjegyzes }}</div></td>
          <td class="kicsi">{{ s.modositotta || s.rogzitette }}<div>{{ (s.modositva || s.rogzitve) | date:'yyyy.MM.dd. HH:mm' }}</div></td>
          <td class="gombok-cella">
            <ng-container *ngIf="s.allapot === 'kiadott'">
              <ion-button size="small" fill="clear" color="danger" (click)="allapotValt(s.id, 'rontott', (s.tanulo_nev || '') + ' – ' + s.sorozat + ' ' + s.sorszam)">Rontott</ion-button>
              <ion-button size="small" fill="clear" color="medium" (click)="allapotValt(s.id, 'bevon', (s.tanulo_nev || '') + ' – ' + s.sorozat + ' ' + s.sorszam)">Bevonás</ion-button>
            </ng-container>
            <ion-button size="small" fill="clear" (click)="megjegyzes(s)">Megjegyzés</ion-button>
          </td>
        </tr>
        <tr *ngIf="!szamadas.length"><td colspan="9" class="halvany">Nincs a szűrésnek megfelelő tétel.</td></tr>
      </tbody>
    </table>

    <h3>Kitöltetlen nyomtatvány elrontva</h3>
    <p class="halvany">Ha egy még ki nem osztott példány romlik el (pl. próbanyomtatásra használták), itt rögzítsd – a sorszáma ezzel lezárul.</p>
    <div class="tomeges">
      <ion-select label="Nyomtatvány" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="uresRontott.tipus" class="kozepes">
        <ion-select-option *ngFor="let n of elrLista" [value]="n.tipus">{{ n.kod }}</ion-select-option>
      </ion-select>
      <ion-input label="Sorozatjel" label-placement="stacked" fill="outline" [(ngModel)]="uresRontott.sorozat" class="rovid"></ion-input>
      <ion-input label="Sorszám" label-placement="stacked" fill="outline" [(ngModel)]="uresRontott.sorszam" class="kozepes"></ion-input>
      <ion-input label="A rontás oka" label-placement="stacked" fill="outline" [(ngModel)]="uresRontott.ok"></ion-input>
      <ion-button color="danger" fill="outline" (click)="uresRontottRogzit()">Rontottként rögzítés</ion-button>
    </div>
  </ng-container>

  <!-- ═══════════════ ÉVFOLYAM-SZABÁLY ═══════════════ -->
  <ng-container *ngIf="ful === 'szabaly' && szabaly">
    <p class="halvany">
      Az Nkt. 99/M. § szerint a digitális bizonyítvány 2025/2026-ban indul felmenő rendszerben: az általános iskola 1.,
      a négy évfolyamos gimnázium 9., a hat évfolyamos gimnázium 7., a nyolc évfolyamos 5. évfolyamán (előkészítő
      évfolyammal szervezett képzésnél a kezdő évfolyamon); szakképző intézményben a 2025/2026-ban kezdőknél (Szkt. 128/C. §).
      A rendszer a képzés kezdő évfolyamából számolja, melyik osztály melyik évjárat. A képzés típusát az intézményre,
      osztály-betűjelre (pl. „E” = hat évfolyamos) vagy osztályonként adhatod meg, és a formát kézzel felülírhatod.
      Ha itt nincs képzés megadva, az Intézménytípus beállítás dönt; szakképzőben tanulónként a jogviszony kezdete.
      Ugyanez a döntés érvényes a digitális bizonyítványra és a díszpéldányra is.
    </p>

    <h3>Intézményi alap</h3>
    <div class="tomeges">
      <ion-select label="Képzés" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="szabaly.alap.kepzes">
        <ion-select-option value="">Becsült (1–8.: általános iskola, 9–: négy évfolyamos)</ion-select-option>
        <ion-select-option *ngFor="let k of szabaly.kepzesek" [value]="k.kulcs">{{ k.nev }}</ion-select-option>
      </ion-select>
      <ion-select label="Forma" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="szabaly.alap.forma" class="kozepes">
        <ion-select-option value="auto">A felmenő rendszer szerint</ion-select-option>
        <ion-select-option value="digitalis">Mindig digitális</ion-select-option>
        <ion-select-option value="papir">Mindig papír</ion-select-option>
      </ion-select>
      <ion-select label="Nyomtatvány" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="szabaly.alap.nyomtatvany_tipus" class="kozepes">
        <ion-select-option value="">A.T. 1001 (alap)</ion-select-option>
        <ion-select-option *ngFor="let n of szabaly.nyomtatvanyok" [value]="n.tipus">{{ n.kod }}</ion-select-option>
      </ion-select>
      <ion-button (click)="szabalyMent('', szabaly.alap.kepzes, szabaly.alap.forma, szabaly.alap.nyomtatvany_tipus)">Mentés</ion-button>
    </div>

    <h3>Osztály-betűjel szabályok</h3>
    <div *ngFor="let b of szabaly.betujelek" class="betujel">
      <b>„{{ b.betujel }}”</b>: {{ b.kepzes ? (b.kepzes) : 'öröklés' }} · {{ b.forma === 'auto' ? 'felmenő rendszer szerint' : formaNev(b.forma) }}
      <ion-button size="small" fill="clear" color="danger" (click)="betujelTorol(b)">Törlés</ion-button>
    </div>
    <div class="tomeges">
      <ion-input label="Betűjel" label-placement="stacked" fill="outline" [(ngModel)]="ujBetujel.betujel" class="rovid" placeholder="E"></ion-input>
      <ion-select label="Képzés" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="ujBetujel.kepzes">
        <ion-select-option value="">Öröklés</ion-select-option>
        <ion-select-option *ngFor="let k of szabaly.kepzesek" [value]="k.kulcs">{{ k.nev }}</ion-select-option>
      </ion-select>
      <ion-select label="Forma" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="ujBetujel.forma" class="kozepes">
        <ion-select-option value="auto">Felmenő rendszer szerint</ion-select-option>
        <ion-select-option value="digitalis">Digitális</ion-select-option>
        <ion-select-option value="papir">Papír</ion-select-option>
      </ion-select>
      <ion-button fill="outline" (click)="betujelMent()">Hozzáadás</ion-button>
    </div>

    <h3>Osztályok ({{ tanevCim }})</h3>
    <table class="tabla">
      <thead><tr><th>Osztály</th><th>Évf.</th><th>Képzés</th><th>Forma</th><th>Indoklás</th><th>Kézi beállítás (csak erre az osztályra)</th></tr></thead>
      <tbody>
        <tr *ngFor="let o of szabaly.osztalyok">
          <td><b>{{ o.osztaly_nev }}</b></td>
          <td>{{ o.evfolyam }}</td>
          <td class="kicsi">{{ o.kepzes_nev }}<div [class.figyel]="o.kepzes_forras === 'becsult'">{{ forrasNev(o.kepzes_forras) }}</div></td>
          <td>
            <ion-badge [color]="o.forma === 'digitalis' ? 'success' : 'warning'">{{ formaNev(o.forma) }}</ion-badge>
            <div class="kicsi" *ngIf="o.felulirt">felülírva</div>
            <div class="kicsi figyel" *ngIf="o.bizonytalan">ellenőrizd!</div>
          </td>
          <td class="kicsi">{{ o.indok }}</td>
          <td>
            <div class="sor-szerk">
              <ion-select interface="popover" [(ngModel)]="o.sajat_kepzes" aria-label="Képzés" placeholder="Képzés: öröklés">
                <ion-select-option value="">Képzés: öröklés</ion-select-option>
                <ion-select-option *ngFor="let k of szabaly.kepzesek" [value]="k.kulcs">{{ k.nev }}</ion-select-option>
              </ion-select>
              <ion-select interface="popover" [(ngModel)]="o.kezi_forma" aria-label="Forma">
                <ion-select-option value="auto">Forma: szabály szerint</ion-select-option>
                <ion-select-option value="digitalis">Digitális</ion-select-option>
                <ion-select-option value="papir">Papír</ion-select-option>
              </ion-select>
              <ion-select interface="popover" [(ngModel)]="o.sajat_nyomtatvany_tipus" aria-label="Nyomtatvány">
                <ion-select-option value="">Nyomtatvány: öröklés</ion-select-option>
                <ion-select-option *ngFor="let n of szabaly.nyomtatvanyok" [value]="n.tipus">{{ n.kod }}</ion-select-option>
              </ion-select>
              <ion-button size="small" fill="outline" (click)="szabalyMent(o.osztaly, o.sajat_kepzes, o.kezi_forma, o.sajat_nyomtatvany_tipus)">Mentés</ion-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="halvany">Az osztályonkénti beállítás csak az adott tanév osztályára vonatkozik (az osztály minden tanévben új); évről évre érvényes szabályhoz a betűjelet használd.</p>
  </ng-container>

  <!-- ═══════════════ ELRENDEZÉS ═══════════════ -->
  <ng-container *ngIf="ful === 'elrendezes' && elr">
    <div class="figyel-doboz">
      <b>A beépített elrendezés pozíciói becsültek.</b> Mérd be egy valódi, kitöltetlen nyomtatványon: nyomtasd ki a
      rácsos tesztlapot sima papírra (tényleges méretben, a 100 mm-es vonalat vonalzóval ellenőrizd), tedd a nyomtatványra,
      és fény felé tartva olvasd le, hová esnek a pontozott sorok. A koordináták a lap <b>bal felső</b> sarkától mm-ben
      értendők; az <b>y</b> a szöveg alapvonala. Ha minden mező egyformán csúszik, a <b>globális eltolást</b> állítsd
      (a nyomtató behúzási hibája). A „Próbanyomtatás” mintaadattal tölti ki a lapot.
    </div>

    <div class="tomeges">
      <ion-select label="Nyomtatványtípus" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="elrTipus" (ionChange)="elrToltes(elrTipus)">
        <ion-select-option *ngFor="let n of elrLista" [value]="n.tipus">{{ n.kod }} – {{ n.nev }}{{ n.bemert ? ' (bemérve)' : ' (alap)' }}</ion-select-option>
      </ion-select>
      <ion-button fill="outline" (click)="ujTipus()">Új típus másolással</ion-button>
      <ion-button fill="clear" color="danger" (click)="elrVisszaallit()">Visszaállítás / törlés</ion-button>
    </div>

    <div class="tomeges">
      <ion-input label="Kód" label-placement="stacked" fill="outline" [(ngModel)]="elr.kod" (ionInput)="valtozott()" class="kozepes"></ion-input>
      <ion-input label="Megnevezés" label-placement="stacked" fill="outline" [(ngModel)]="elr.nev" (ionInput)="valtozott()"></ion-input>
      <ion-input label="Betűméret (pt)" label-placement="stacked" fill="outline" type="number" [(ngModel)]="elr.betu" (ionInput)="valtozott()" class="rovid"></ion-input>
      <ion-input label="Legkisebb (pt)" label-placement="stacked" fill="outline" type="number" [(ngModel)]="elr.minBetu" (ionInput)="valtozott()" class="rovid"></ion-input>
      <ion-input label="Eltolás X (mm, + jobbra)" label-placement="stacked" fill="outline" type="number" step="0.5" [(ngModel)]="elr.offset.x" (ionInput)="valtozott()" class="kozepes"></ion-input>
      <ion-input label="Eltolás Y (mm, + lefelé)" label-placement="stacked" fill="outline" type="number" step="0.5" [(ngModel)]="elr.offset.y" (ionInput)="valtozott()" class="kozepes"></ion-input>
    </div>
    <ion-input label="Ha a szöveges értékelés nem fér el, ez kerül a helyére" label-placement="stacked" fill="outline" [(ngModel)]="elr.hosszuSzoveg" (ionInput)="valtozott()"></ion-input>

    <ion-segment [(ngModel)]="elrOldal" [scrollable]="true" class="oldal-valaszto">
      <ion-segment-button *ngFor="let o of elr.oldalak" [value]="o.kulcs"><ion-label>{{ o.nev || o.kulcs }}</ion-label></ion-segment-button>
    </ion-segment>

    <ng-container *ngIf="aktOldal as o">
      <div class="tomeges">
        <ion-input label="Oldal neve" label-placement="stacked" fill="outline" [(ngModel)]="o.nev" (ionInput)="valtozott()"></ion-input>
        <ion-input label="Szélesség (mm)" label-placement="stacked" fill="outline" type="number" [(ngModel)]="o.szelesseg" (ionInput)="valtozott()" class="rovid"></ion-input>
        <ion-input label="Magasság (mm)" label-placement="stacked" fill="outline" type="number" [(ngModel)]="o.magassag" (ionInput)="valtozott()" class="rovid"></ion-input>
        <ion-checkbox [(ngModel)]="o.egyszer" (ionChange)="valtozott()" labelPlacement="end">Egyszer kitöltendő (személyi adatok)</ion-checkbox>
      </div>

      <table class="tabla mezok">
        <thead><tr><th>Mező</th><th>X (mm)</th><th>Y (mm)</th><th>Szél. (mm)</th><th>Betű (pt)</th><th>Igazítás</th><th>Sorok / sorköz</th><th>Be</th><th></th></tr></thead>
        <tbody>
          <ng-container *ngFor="let m of o.mezok; let i = index">
            <tr>
              <td>
                <ion-select interface="popover" [(ngModel)]="m.kulcs" (ionChange)="valtozott()" aria-label="Mező">
                  <ion-select-option *ngFor="let k of mezoKulcsok" [value]="k">{{ mezoNevek[k] }}</ion-select-option>
                </ion-select>
              </td>
              <td><ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="m.x" (ionInput)="valtozott()" aria-label="X"></ion-input></td>
              <td><ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="m.y" (ionInput)="valtozott()" aria-label="Y"></ion-input></td>
              <td><ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="m.w" (ionInput)="valtozott()" aria-label="Szélesség" [readonly]="m.tipus === 'tablazat'"></ion-input></td>
              <td><ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="m.meret" (ionInput)="valtozott()" placeholder="alap" aria-label="Betűméret"></ion-input></td>
              <td>
                <ion-select interface="popover" [(ngModel)]="m.igazitas" (ionChange)="valtozott()" aria-label="Igazítás" placeholder="bal">
                  <ion-select-option value="bal">bal</ion-select-option>
                  <ion-select-option value="kozep">közép</ion-select-option>
                  <ion-select-option value="jobb">jobb</ion-select-option>
                </ion-select>
              </td>
              <td>
                <ng-container *ngIf="m.tipus === 'tablazat'">
                  <ion-input class="cella szam" type="number" [(ngModel)]="m.maxSor" (ionInput)="valtozott()" aria-label="Sorok száma"></ion-input>
                  <ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="m.sorkoz" (ionInput)="valtozott()" aria-label="Sorköz"></ion-input>
                </ng-container>
                <ng-container *ngIf="m.tipus !== 'tablazat'">
                  <ion-input class="cella szam" type="number" [(ngModel)]="m.sorok" (ionInput)="sorokValt(m)" placeholder="1" aria-label="Sorok száma"></ion-input>
                  <ion-input *ngIf="m.sorok > 1" class="cella szam" type="number" step="0.5" [(ngModel)]="m.sorkoz" (ionInput)="valtozott()" aria-label="Sorköz"></ion-input>
                </ng-container>
              </td>
              <td><ion-checkbox [checked]="m.ki !== false" (ionChange)="kiValt(m, $event.detail.checked)" aria-label="Nyomtatandó"></ion-checkbox></td>
              <td><ion-button size="small" fill="clear" color="danger" (click)="mezoTorol(i)" *ngIf="m.tipus !== 'tablazat'">✕</ion-button></td>
            </tr>
            <tr *ngIf="m.tipus === 'tablazat'" class="oszlopok">
              <td colspan="9">
                <span class="kicsi">Oszlopok (a táblázat bal szélétől):</span>
                <span *ngFor="let c of m.oszlopok" class="oszlop">
                  <ion-select interface="popover" [(ngModel)]="c.mezo" (ionChange)="valtozott()" aria-label="Oszlop">
                    <ion-select-option *ngFor="let k of oszlopKulcsok" [value]="k">{{ oszlopNevek[k] }}</ion-select-option>
                  </ion-select>
                  <ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="c.dx" (ionInput)="valtozott()" aria-label="Eltolás" placeholder="dx"></ion-input>
                  <ion-input class="cella szam" type="number" step="0.5" [(ngModel)]="c.w" (ionInput)="valtozott()" aria-label="Szélesség" placeholder="szél."></ion-input>
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <ion-button size="small" fill="clear" (click)="ujMezo()"><ion-icon slot="start" name="add-outline"></ion-icon>Új mező</ion-button>
    </ng-container>

    <div class="gombok">
      <ion-button fill="outline" (click)="elrPdf('tesztlap')"><ion-icon slot="start" name="grid-outline"></ion-icon>Rácsos tesztlap (ez az oldal)</ion-button>
      <ion-button fill="outline" (click)="elrPdf('proba', true)"><ion-icon slot="start" name="eye-outline"></ion-icon>Próbanyomtatás kerettel</ion-button>
      <ion-button fill="outline" (click)="elrPdf('proba', false)"><ion-icon slot="start" name="print-outline"></ion-icon>Próbanyomtatás (csak adat)</ion-button>
      <ion-button (click)="elrMent()" [disabled]="!elrValtozott"><ion-icon slot="start" name="save-outline"></ion-icon>Mentés</ion-button>
    </div>
  </ng-container>

  <!-- ═══════════════ SABLONOK ═══════════════ -->
  <ng-container *ngIf="ful === 'sablon'">
    <div class="figyel-doboz">
      <ion-icon name="warning-outline"></ion-icon>
      <b>{{ sablonFigyelmeztetes }}</b>
      <div class="halvany">Nkt. 57. § (5): az iskolában csak a köznevelésért felelős miniszter által jóváhagyott bizonyítványnyomtatvány alkalmazható. A papír bizonyítványt a Nyomtatás fülön, a jóváhagyott nyomtatványra töltsd ki.</div>
    </div>

    <ion-list lines="full">
      <ion-item *ngFor="let s of sablonok">
        <ion-label class="ion-text-wrap">
          <h2>{{ s.nev }}</h2>
          <p><code>{{ s.ut }}</code> – {{ s.megvan ? 'feltöltve' + (s.modositva ? ', ' + (s.modositva | date:'yyyy.MM.dd. HH:mm') : '') : 'nincs feltöltve' }}</p>
          <!-- 20/2012. EMMI r. 96. §: a régi sablonból hiányzó elemek (a generálás ettől még megy) -->
          <p *ngIf="sablonHianyok[s.kulcs]?.length" class="figyel-szoveg">
            <ion-icon name="warning-outline" color="warning"></ion-icon>
            A sablonból hiányzik (20/2012. EMMI r. 96. §): {{ hianyFelsorolas(s.kulcs) }}. A bizonyítvány így is elkészül,
            de ezek az adatok nem kerülnek rá – tölts fel frissített sablont (kiindulásnak a beépített alapsablon letölthető).
          </p>
          <p *ngIf="s.kulcs === 'bizonyitvany' && sablonHianyok[s.kulcs] && !sablonHianyok[s.kulcs].length" class="halvany">
            A sablon a 96. § minden elemét tartalmazza.
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <div class="gombok">
      <ion-button fill="outline" size="small" (click)="alapsablonLetoltes()">
        <ion-icon slot="start" name="download-outline"></ion-icon>A 96. §-os alapsablon letöltése (bizonyitvany-96.docx)
      </ion-button>
    </div>

    <h3>Sablon feltöltése</h3>
    <div class="tomeges">
      <ion-select label="Sablon" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="sablonKulcs">
        <ion-select-option *ngFor="let s of sablonok" [value]="s.kulcs">{{ s.nev }}</ion-select-option>
      </ion-select>
      <input type="file" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="sablonValaszt($event)" />
    </div>
    <ion-item lines="none">
      <ion-checkbox [(ngModel)]="sablonTudomasul" labelPlacement="end" class="ion-text-wrap">
        Tudomásul veszem: ez a sablon csak a digitális bizonyítványhoz és a díszpéldányhoz használható, papír bizonyítvány nem nyomtatható vele.
      </ion-checkbox>
    </ion-item>
    <div class="gombok">
      <ion-button (click)="sablonFeltolt()" [disabled]="fut || !sablonFajl || !sablonTudomasul">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>Feltöltés
      </ion-button>
    </div>
  </ng-container>
</ion-content>
